'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ type: 'radio' }, {
    block: 'button2',
    onClick: function onClick(e) {
        this.__base.apply(this, arguments);
        this.setState({ checked: true });
    }
}, {
    propTypes: {
        type: _propTypes2.default.string
    }
});